<footer class="footer">
    <div class="button-wrapper">
        <button [routerLink]="backLink"
                class="back" fxLayoutAlign="start center"
                [disabled]="isBackLinkDisabled">
            <i class="ju ju-chevron_left"></i>
            <span>Zurück</span>
        </button>

        <button *ngIf="!isLast" [routerLink]="nextLink"
                class="next" fxLayoutAlign="center center"
                [disabled]="isNextLinkDisabled">
            Weiter
            <span class="validation-overflow" (click)="validate.emit()"></span>
        </button>
        <button *ngIf="isLast" (click)="showPreviewPopup()" class="next"
                fxLayoutAlign="center center"
                [disabled]="isNextLinkDisabled">
            Abschließen
            <span class="validation-overflow"
                  (click)="validate.emit()">
                </span>
        </button>
    </div>
</footer>
